import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'newLineCharToHtmlLineBreak',
  standalone: true,
})
export class NewLineCharToHtmlLineBreak implements PipeTransform {
  transform(text: string): string {
    if (typeof text !== 'string') {
      text = text == null ? '' : String(text);
    }

    return text.replace(/\r?\n/g, '<br/>');
  }
}
